export function buildPosition(play) {
  const now = new Date();

  const dte =
    play.dte ||
    (String(play.contract || "").includes("14-21D")
      ? 21
      : String(play.contract || "").includes("21-30D")
      ? 30
      : String(play.contract || "").includes("30-45D")
      ? 45
      : 30);

  const expirationDate = new Date(
    now.getTime() + dte * 24 * 60 * 60 * 1000
  );

  return {
    ticker: play.ticker,

    contract: play.contract || "",

    stock_entry: Number(play.price || play.lastPrice || 0),
    stock_current: Number(play.price || play.lastPrice || 0),

    // Estimated option pricing until broker integration
    option_entry: 5.0,
    option_current: 5.0,

    opened_at: now.toISOString(),

    expiration_date: expirationDate.toISOString().split("T")[0],

    target:
      play.price_target ||
      play.target ||
      "",

    thesis:
      play.stage ||
      play.structure ||
      play.thesis ||
      "",

    status: "OPEN",

    dte,

    result: "OPEN",

    notes: "",

    source: "MSI_UNIVERSE",
  };
}
